// this file was auto-generated by rake i18n:generate_js.
// you probably shouldn't edit it directly
import mergeI18nTranslations from '@canvas/i18n/mergeI18nTranslations.js';

// we use JSON.parse here instead of just loading it as a javascript object literal
// because according to https://v8.dev/blog/cost-of-javascript-2019#json that is faster
mergeI18nTranslations(JSON.parse("{\"ru\":{\"registration\":{\"teacher_dialog\":{\"buttons\":{\"start_teaching\":\"Начать обучение\"},\"labels\":{\"email\":\"Электронная почта\",\"name\":\"Имя\"}}}},\"uk\":{\"registration\":{\"teacher_dialog\":{\"buttons\":{\"start_teaching\":\"Почати викладання\"},\"labels\":{\"email\":\"Електронна адреса\",\"name\":\"Ім'я\"}}}}}"));
